module.exports = __webpack_public_path__ + "static/media/NotiBot.84402107.webp";